import React, { useState, useEffect } from 'react';

import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import { useGoogleLogin } from '@react-oauth/google';
import AppleLogin from 'react-apple-login'

const Register = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);
    const [inputData, setInputData] = useState({
        email: "",
        password: "",
    });

    const [user, setUser] = useState(null);


    const login = useGoogleLogin({
        onSuccess: (codeResponse) => setUser(codeResponse),
        onError: (error) => console.log('Registration Failed:', error)
    });


    useEffect(

        () => {
            setErrorResponse(null);
            document.title = 'Roam Pays: Register';
        }, []);

    useEffect(
        () => {
            if (user) {

                // console.log(user);
                setIsBtn(true);
                axios.post(process.env.REACT_APP_API_URL + "/register-google", {
                    access_token: user.access_token,
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true
                })
                    .then(function (response) {
                        setIsBtn(false)
                        if (response?.data?.status) {


                            localStorage.setItem("@email", response?.data?.user.email)
                            localStorage.setItem('@roampays-user', response?.data?.user)
                            navigate("/calculate");


                        }
                        else{
                            if("User with this email already exists."==response?.data?.message)
                                {
                                    localStorage.setItem("@email-login-exists", "You are already registered. Please enter email to login.")
                                    navigate("/login");
                            
                                }
                                else{
                                setErrorResponse(response?.data?.message);
                            }
                        }
                    })
                    .catch(function (error) {
                        setIsBtn(false)
                        setErrorResponse(error.message);

                    });



            }
        }, [user]);


    const appleResponse = response => {

         // console.log(response);
        if (!response.error) {
            axios.post(process.env.REACT_APP_API_URL + "/register-apple", response, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {


                        localStorage.setItem("@email", response?.data?.user.email)
                        localStorage.setItem('@roampays-user', response?.data?.user)
                        navigate("/calculate");


                    }
                    else{

if("User with this email already exists."==response?.data?.message)
    {
        localStorage.setItem("@email-login-exists", "You are already registered. Please enter email to login.")
        navigate("/login");

    }
    else{
    setErrorResponse(response?.data?.message);
}

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)
                    setErrorResponse(error.message);

                });

        }
    };


    const handleRegisterEmail = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(null);

        const { email } = inputData;
        if (!email) {
            setInputError(true);
            setIsBtn(false)
        } else {

            setInputError(false);
            await axios.post(process.env.REACT_APP_API_URL + "/register-email", {
                email: email,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {


                        localStorage.setItem("@email", email)
                        navigate("/register-otp");



                    } else {

                        if("User with this email already exists in our system.!"==response?.data?.message)
                        {
                            localStorage.setItem("@email-login-exists", "You are already registered. Please enter email to login.")
                            navigate("/login");

                        }
                        else{
                        setErrorResponse(response?.data?.message);
                    }
                        //Swal.fire({ icon: "error", title: "Registration Failed", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Registration Failed", text: error.message });

                });

        }
    };




    return (


        <div class="form-container">

            {errorResponse &&
                <div className="color-white fs-14" role="alert">
                    {errorResponse}
                </div>
            }
            <h3 className="form-title color-white">Create An Account</h3>

            <div className="input-text" >
                <label className="color-light fs-12">Email Address</label>

                <input type="text" className="color-light fs-14" id="email"
                    name="email" value={inputData.email}
                    onChange={(e) => setInputData({ ...inputData, email: e.target.value })}
                />

                {inputError && !inputData.email && (
                    <span className="color-white fs-10">This field is required</span>
                )}
            </div>

            <button type="button" onClick={handleRegisterEmail} className="button-purple fs-14 color-white" disabled={isBtn}>
                {isBtn ? <Loading size={'20px'} /> : 'Continue'}
            </button>



            <div className="content fs-12 color-white" >
                Already have an account? <Link className="" to="/login">Log in</Link>
            </div>

            <div className="divider" >
                <div className="line"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2" viewBox="0 0 100% 2" fill="none">
                    <path d="M0.5 1.36963H182.5" stroke="#292929" stroke-linecap="round" />
                </svg></div>
                <label className="fs-12 color-white"> OR </label>
                <div className="line"><svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2" viewBox="0 0 100% 2" fill="none">
                    <path d="M0.5 1.36963H182.5" stroke="#292929" stroke-linecap="round" />
                </svg></div>
            </div>

            <div class="button-grey-group" >

                <AppleLogin
                    clientId="com.roampays"
                    redirectURI="https://roampays.com/login-apple"
                    usePopup={true}
                    callback={appleResponse} // Catch the response
                    scope="email name"
                    responseType="code"
                    responseMode="query"
                    render={renderProps => (  //Custom Apple Sign in Button
                        <button onClick={renderProps.onClick} type="button" className="button-grey fs-14 color-white" disabled={isBtn}>
                            {isBtn ? <Loading size={'20px'} /> : <><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                <path d="M13.7005 9.83866C13.7216 12.1087 15.6919 12.864 15.7137 12.8737C15.6971 12.9269 15.3989 13.9501 14.6757 15.0071C14.0505 15.9209 13.4016 16.8312 12.3795 16.8501C11.3751 16.8686 11.0521 16.2545 9.90384 16.2545C8.75591 16.2545 8.39708 16.8313 7.44633 16.8686C6.45968 16.906 5.70834 15.8805 5.07798 14.9701C3.78985 13.1078 2.80546 9.70771 4.12725 7.41259C4.78389 6.27282 5.95735 5.55107 7.23104 5.53256C8.1999 5.51408 9.11436 6.18438 9.70666 6.18438C10.2986 6.18438 11.4099 5.37828 12.5781 5.49667C13.0672 5.51703 14.4401 5.69423 15.3216 6.98458C15.2506 7.02861 13.6835 7.94087 13.7005 9.83866ZM11.8129 4.2646C12.3367 3.63055 12.6893 2.74788 12.5931 1.86963C11.8381 1.89998 10.9251 2.37277 10.3835 3.00648C9.89814 3.56766 9.47308 4.46586 9.58777 5.32673C10.4293 5.39184 11.2891 4.89906 11.8129 4.2646Z" fill="white" />
                            </svg> Continue with Apple</>}
                        </button>
                    )}
                />



                <button type="button" className="button-grey fs-14 color-white" disabled={isBtn} onClick={login} >
                    {isBtn ? <Loading size={'20px'} /> : <><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M15.2 8.53625C15.2 7.91959 15.15 7.46959 15.0417 7.00293H8V9.78623H12.1333C12.05 10.4779 11.6 11.5196 10.6 12.2196L10.586 12.3127L12.8124 14.0375L12.9667 14.0529C14.3833 12.7446 15.2 10.8196 15.2 8.53625Z" fill="#4285F4" />
                        <path d="M8.00001 15.8697C10.025 15.8697 11.725 15.203 12.9667 14.053L10.6 12.2196C9.96667 12.6613 9.11665 12.9696 8.00001 12.9696C6.01669 12.9696 4.33337 11.6614 3.73331 9.85303L3.64535 9.8605L1.33026 11.6522L1.29999 11.7363C2.53331 14.1863 5.06665 15.8697 8.00001 15.8697Z" fill="#34A853" />
                        <path d="M3.7333 9.85283C3.57497 9.38617 3.48334 8.88613 3.48334 8.36949C3.48334 7.85279 3.57497 7.35281 3.72497 6.88615L3.72078 6.78676L1.37668 4.96631L1.29998 5.00279C0.79167 6.01947 0.5 7.16116 0.5 8.36949C0.5 9.57782 0.79167 10.7194 1.29998 11.7361L3.7333 9.85283Z" fill="#FBBC05" />
                        <path d="M8.00001 3.76961C9.40832 3.76961 10.3583 4.37794 10.9 4.88631L13.0166 2.81963C11.7167 1.6113 10.025 0.869629 8.00001 0.869629C5.06665 0.869629 2.53331 2.55295 1.29999 5.00293L3.72498 6.88629C4.33337 5.07796 6.01669 3.76961 8.00001 3.76961Z" fill="#EB4335" />
                    </svg> Continue with Google</>}
                </button>
            </div>

        </div>


    );
};

export default Register;